<style lang="less" scoped>
.apply-list {
  padding: 10px;
  box-sizing: border-box;
  background: #f3f3f3;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  .header {
    position: relative;
    background: #fff;
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    justify-content: center;
    // align-items: center;
    .search-info {
      position: absolute;
      right: 32px;
      height: 32px;
    }
    .clear-info {
      position: absolute;
      right: 142px;
      height: 32px;
    }
  }
  .content {
    position: relative;
    background: #fff;
    padding: 12px;
    box-sizing: border-box;
  }
  .footer {
    position: relative;
    background: #fff;
    padding: 12px;
    box-sizing: border-box;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}
</style>
<template>
  <div class="apply-list">
    <div class="header">
      <Input
        @on-search="GetStudentInfo"
        @on-change="GetStudentInfo"
        v-model="teacherName"
        clearable
        search
        enter-button="搜索"
        placeholder="输入老师姓名或手机号"
        style="width:360px;"
      />
    </div>
    <div class="content">
      <i-table border :columns="teacherShowList" :data="applyList"/>
    </div>
    <div class="footer">
      <Page
        :total="count"
        :page-size="pageSize"
        :page-size-opts="[10, 20]"
        show-total
        @on-change="ChangePage"
        @on-page-size-change="ChangePageSize"
        show-elevator
        show-sizer
      />
    </div>
  </div>
</template>
<script>
import schoolApi from '@/lib/api/school'
const DAT_MINI_SECOND = 3600 * 1000 * 24
export default {
  name: '',
  data() {
    return {
      count: 0,
      number: 6,
      start: 0,
      teacherName: '',
      pageSize: 10,
      dateTime: [], // 起止日期
      applyList: [],
      shortcutsOption: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date()
              const start = new Date()
              return [start, end]
            }
          },
          {
            text: '昨天',
            value() {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND)
              end.setTime(end.getTime() - DAT_MINI_SECOND)
              return [start, end]
            }
          },
          {
            text: '过去7天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 7)
              return [start, end]
            }
          },
          {
            text: '过去30天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
              return [start, end]
            }
          }
          // {
          //   text: '过去60天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 60);
          //     return [start, end];
          //   }
          // },
          // {
          //   text: '过去90天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 90);
          //     return [start, end];
          //   }
          // }
        ]
      },
      teacherShowList: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '班级名称',
          key: 'type'
        },
        {
          title: '教师姓名',
          key: 'type'
        },
        {
          title: '班级学生数',
          key: 'mobile'
        },
        {
          title: '开始日期',
          key: 'date_time'
        },
        {
          title: '结束日期',
          key: 'date_time'
        },
        {
          title: '状态',
          key: 'date_time'
        },
        {
          title: '开始日期',
          key: 'date_time'
        }
      ],
      showList: []
    }
  },
  created() {
    this.GetStudentInfo()
    console.log('1' + this.dateTime)
  },
  methods: {
    ClearDate() {
      this.dateTime = []
    },
    ClearAll() {
      this.dateTime = []
      this.GetStudentInfo()
    },
    SetNewAvgDate(format) {
      this.dateTime = format
      console.log(this.dateTime)
    },
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.GetStudentInfo()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.GetStudentInfo()
    },
    GetStudentInfo() {
      console.log(this.dateTime)
      if (this.dateTime[0] == '') {
        this.dateTime = []
      }
      schoolApi
        .GetApplyList({
          startTime:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[0]).format('yyyy-MM-dd'),
          endTime:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[1]).format('yyyy-MM-dd'),
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          const applyData = res.data
          this.count = applyData.count // 总条数
          // this.applyList = applyData.list
          this.applyList = applyData.list.map(item => {
            if (item.source_type == 1) {
              item.type = '作业'
            } else if (item.source_type == 2) {
              item.type = '作品'
            } else if (item.source_type == 3) {
              item.type = '打卡活动'
            }
            return {
              ...item,
              type: item.type
            }
          }) // 点读作品列表
          console.log(applyData)
        })
    }
  }
}
</script>
